import React from 'react';
import { FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@material-ui/core';
import { Typography } from 'components';
import { useReduxSelector } from 'store/hooks';
import { doubleHospitalRadiusSite } from 'config/constants';

const TimeAndCoordinate = ({ config, draft, setDraft }) => {
  const onChange = (key, value) => setDraft({ ...draft, [key]: value });
  const app = useReduxSelector((state) => state.app);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography type="bold">Zona Waktu</Typography>
        <RadioGroup
          name="timezoneCode"
          defaultValue={config?.timezoneCode}
          value={draft?.timezoneCode}
          onChange={(e) => onChange('timezoneCode', e.target.value)}
          row={true}
        >
          <FormControlLabel value="WIB" control={<Radio color="primary" />} label="WIB" />
          <FormControlLabel value="WITA" control={<Radio color="primary" />} label="WITA" />
          <FormControlLabel value="WIT" control={<Radio color="primary" />} label="WIT" />
        </RadioGroup>
      </Grid>
      <Grid item xs={12}>
        <Typography type="bold">Kordinat</Typography>
      </Grid>
      {doubleHospitalRadiusSite.includes(app.env.projectId) ? (
        <>
          {/* FIRST RADIUS */}
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.hospitalCoordinate1?.latitude}
              fullWidth
              label="Latitude"
              type="number"
              value={draft?.hospitalCoordinate1?.latitude}
              onChange={(e) =>
                onChange('hospitalCoordinate1', {
                  ...config.hospitalCoordinate1,
                  ...draft?.hospitalCoordinate1,
                  ...{ latitude: parseFloat(e.target.value) },
                })
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.hospitalCoordinate1?.longitude}
              fullWidth
              label="Longitude"
              type="number"
              value={draft?.hospitalCoordinate1?.longitude}
              onChange={(e) =>
                onChange('hospitalCoordinate1', {
                  ...config.hospitalCoordinate1,
                  ...draft?.hospitalCoordinate1,
                  ...{ longitude: parseFloat(e.target.value) },
                })
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.distanceTolerance1}
              fullWidth
              label="Radius(m)"
              type="number"
              value={draft?.distanceTolerance1}
              onChange={(e) => onChange('distanceTolerance1', parseInt(e.target.value))}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          {/* SECOND RADIUS */}
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.hospitalCoordinate2?.latitude}
              fullWidth
              label="Latitude"
              type="number"
              value={draft?.hospitalCoordinate2?.latitude}
              onChange={(e) =>
                onChange('hospitalCoordinate2', {
                  ...config.hospitalCoordinate2,
                  ...draft?.hospitalCoordinate2,
                  ...{ latitude: parseFloat(e.target.value) },
                })
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.hospitalCoordinate2?.longitude}
              fullWidth
              label="Longitude"
              type="number"
              value={draft?.hospitalCoordinate2?.longitude}
              onChange={(e) =>
                onChange('hospitalCoordinate2', {
                  ...config.hospitalCoordinate2,
                  ...draft?.hospitalCoordinate2,
                  ...{ longitude: parseFloat(e.target.value) },
                })
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.distanceTolerance2}
              fullWidth
              label="Radius(m)"
              type="number"
              value={draft?.distanceTolerance2}
              onChange={(e) => onChange('distanceTolerance2', parseInt(e.target.value))}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.hospitalCoordinate?.latitude}
              fullWidth
              label="Latitude"
              type="number"
              value={draft?.hospitalCoordinate?.latitude}
              onChange={(e) =>
                onChange('hospitalCoordinate', {
                  ...config.hospitalCoordinate,
                  ...draft?.hospitalCoordinate,
                  ...{ latitude: parseFloat(e.target.value) },
                })
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.hospitalCoordinate?.longitude}
              fullWidth
              label="Longtitude"
              type="number"
              value={draft?.hospitalCoordinate?.longitude}
              onChange={(e) =>
                onChange('hospitalCoordinate', {
                  ...config.hospitalCoordinate,
                  ...draft?.hospitalCoordinate,
                  ...{ longitude: parseFloat(e.target.value) },
                })
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              defaultValue={config?.distanceTolerance}
              fullWidth
              label="Radius(m)"
              type="number"
              value={draft?.distanceTolerance}
              onChange={(e) => onChange('distanceTolerance', parseInt(e.target.value))}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default TimeAndCoordinate;
